export default function avatarNone(color?: string) {
  return `<svg width="108px" height="108px" viewBox="0 0 108 108" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> 
  <g id="Avatar" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
  <g id="Group">
      <circle id="Background" fill="#E0E3E9" cx="54" cy="54" r="54"></circle>
      <g id="-Round-/-Social-/-person" transform="translate(9.000000, 9.000000)">
          <polygon id="Path" points="0 0 90 0 90 90 0 90"></polygon>
          <path d="M45,45 C53.2875,45 60,38.2875 60,30 C60,21.7125 53.2875,15 45,15 C36.7125,15 30,21.7125 30,30 C30,38.2875 36.7125,45 45,45 Z M45,52.5 C34.9875,52.5 15,57.525 15,67.5 L15,71.25 C15,73.3125 16.6875,75 18.75,75 L71.25,75 C73.3125,75 75,73.3125 75,71.25 L75,67.5 C75,57.525 55.0125,52.5 45,52.5 Z" id="Icon-Color" fill="${color}"></path>
      </g>
  </g>
</g>
    
</svg>`
}
